<script>
    import Log from "./Log.svelte";
    import {app_state, logUserEntry} from "../stores/misc";

    export let type;
    export let owner_id;
    export let logs;

    let new_user_created_log = '';
    const reset = () => {
        new_user_created_log = '';
    };

    let should_show_log_entry = false;
    let apply_autofocus = false;
    const addLogButtonClicked = () => {
        apply_autofocus = true;
        should_show_log_entry = true;
    }
    const handleCancelLogEntry = () => {
        should_show_log_entry = false;
        reset();
    }
    const handleSaveLog = async () => {
        let new_log = await logUserEntry($app_state.username, type, owner_id, new_user_created_log);
        logs.unshift(new_log);
        logs = logs;
        reset();
    };
</script>

{#if !should_show_log_entry}
    <div class="bg-gray-50 px-4 py-6 sm:px-6">
        <div class="justify-stretch flex flex-col-reverse space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-y-0 sm:space-x-3 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
            <button on:click={addLogButtonClicked}
                    type="button"
                    class="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
            >Log Event</button>
        </div>
    </div>
{/if}

{#if should_show_log_entry}
    <!--Log Entry-->
    <div class="bg-gray-50 px-4 py-6 sm:px-6">

        <div class="min-w-0 flex-1">
            <form class="relative">
                <div class="overflow-hidden bg-white rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600">
                    <label for="comment" class="sr-only">Log an event</label>
                    <textarea bind:value={new_user_created_log} on:blur={() => apply_autofocus = false} autofocus="{apply_autofocus}" rows="3" name="comment" id="comment" class="block w-full resize-none border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:py-1.5 sm:text-sm sm:leading-6" placeholder="Log an event..."></textarea>

                    <!-- Spacer element to match the height of the toolbar -->
                    <div class="py-2" aria-hidden="true">
                        <!-- Matches height of button in toolbar (1px border + 36px content height) -->
                        <div class="py-px">
                            <div class="h-9"></div>
                        </div>
                    </div>
                </div>

                <div class="absolute inset-x-0 bottom-0 flex justify-end py-2 pl-3 pr-2">
                    <div class="flex flex-shrink-0 items-center space-x-2">
                        <button on:click|preventDefault={handleCancelLogEntry} type="submit" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400">Cancel</button>
                        <button on:click|preventDefault={handleSaveLog} type="submit" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Log</button>
                    </div>
                </div>
            </form>
        </div>

    </div>
{/if}


<!-- Timeline -->
<section aria-labelledby="timeline-title" class="lg:col-span-1 lg:col-start-3">
    <div class="bg-white py-5 px-4 sm:px-6 lg:px-8">
        <h2 id="timeline-title" class="text-lg font-medium text-gray-900">Timeline</h2>

        <!-- Activity Feed -->
        <div class="mt-6 flow-root">
            <ul class="-mb-8">
                {#each logs as log, i (log.id)}
                <Log bind:log is_last={i === logs.length - 1}></Log>
                {/each}
            </ul>
        </div>
    </div>
</section>


<style></style>